var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.477 9.29302L14 12.823L12.8262 14L9.30655 10.4733C8.13308 11.3588 6.66843 11.7662 5.20733 11.6133C3.74623 11.4604 2.39715 10.7587 1.43156 9.64939C0.465974 8.54005 -0.0444383 7.10543 0.00303815 5.63422C0.0505146 4.16302 0.652356 2.76443 1.68745 1.71992C2.72254 0.6754 4.11405 0.0624876 5.58195 0.00452045C7.04985 -0.0534467 8.48519 0.447834 9.59911 1.40749C10.713 2.36714 11.4229 3.71393 11.5857 5.17682C11.7486 6.63972 11.3525 8.11015 10.477 9.29218V9.29302ZM9.96068 5.82287C9.96068 4.71988 9.52339 3.66206 8.74501 2.88212C7.96663 2.10219 6.91092 1.66403 5.81012 1.66403C4.70932 1.66403 3.65361 2.10219 2.87523 2.88212C2.09685 3.66206 1.65956 4.71988 1.65956 5.82287C1.65956 6.92587 2.09685 7.98369 2.87523 8.76362C3.65361 9.54356 4.70932 9.98172 5.81012 9.98172C6.91092 9.98172 7.96663 9.54356 8.74501 8.76362C9.52339 7.98369 9.96068 6.92587 9.96068 5.82287Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ab0b984398aac5a546de52a04735c4b5.svg";
export { ForwardRef as ReactComponent };